var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSquare11AError = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  stroke: "#DB5C67",
  strokeWidth: 2,
  d: "M27 22.5a1.5 1.5 0 0 1 1.5-1.5h15a1.5 1.5 0 0 1 1.5 1.5v15a1.5 1.5 0 0 1-1.5 1.5h-15a1.5 1.5 0 0 1-1.5-1.5v-15Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M12 35V25l8.274-.752A2.5 2.5 0 0 1 23 26.738v6.524a2.5 2.5 0 0 1-2.726 2.49L12 35Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB5C67",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m14 36-.445-.223A2.813 2.813 0 0 1 12 33.262v-6.524c0-1.065.602-2.039 1.555-2.515L14 24"
})));
SvgSquare11AError.viewBox = '0 0 60 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgSquare11AError);
export default ForwardRef;